/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestPasswordReset
 */
export interface RequestPasswordReset {
    /**
     * 
     * @type {string}
     * @memberof RequestPasswordReset
     */
    mail: string;
}

/**
 * Check if a given object implements the RequestPasswordReset interface.
 */
export function instanceOfRequestPasswordReset(value: object): value is RequestPasswordReset {
    if (!('mail' in value) || value['mail'] === undefined) return false;
    return true;
}

export function RequestPasswordResetFromJSON(json: any): RequestPasswordReset {
    return RequestPasswordResetFromJSONTyped(json, false);
}

export function RequestPasswordResetFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestPasswordReset {
    if (json == null) {
        return json;
    }
    return {
        
        'mail': json['mail'],
    };
}

export function RequestPasswordResetToJSON(json: any): RequestPasswordReset {
    return RequestPasswordResetToJSONTyped(json, false);
}

export function RequestPasswordResetToJSONTyped(value?: RequestPasswordReset | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mail': value['mail'],
    };
}

